import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useKitCreateSyncMutation = createMutationHook(
  CreatorIntegrationsApiClient.createKitSyncJob,
  {
    mutationKey: ['createKitSync'],
  },
)
